<div class="w-full  sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">


    <!--############################################################-->
    <div class="bg-white rounded-lg p-4">
        <!-- ##########################################################  -->
        <!-- ##########################################################  --> 
        <div class="w-full">
            <!-- ##########################################################  -->  
            <div class="grid grid-cols-10">   
                <div class="col-span-8">
                    <!-- ## -->
                    <h2 class="prose prose-xl">Producto <b> {{data.name}} </b>  </h2>                       
                    <h2 class="prose "><small>SKU <b> {{data.SKU}} </b></small></h2>                                   
                       <!--  <h2 class="prose "> Editar Guia Entrada </h2>   -->
                    <!-- ## -->
                </div>
                <div class="col-span-1">
                    <!-- ## -->
                   <!--  <button class="close " mat-button (click)="closeBtn()"> <mat-icon>close</mat-icon></button> -->   
                   <button class="close " mat-button mat-dialog-close> <mat-icon>close</mat-icon></button>
                    <!-- ## -->
                </div>
            </div>
            <!-- ##########################################################  -->    
    
        </div>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
    <mat-divider class="py-2"></mat-divider>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
        <form [formGroup]="storageLevelForm">
            <mat-form-field class="w-full">
                <mat-label> Bodega </mat-label>
                <mat-select formControlName="uuidWarehouse">
                    <ng-container *ngFor="let warehouse of warehousesFiltered">
                        <mat-option [value]="warehouse.UUID_WAREHOUSE">
                            {{warehouse.NAME_WAREHOUSE}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Nivel Minimo</mat-label>
                <input matInput formControlName="minLevel" type="number">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Nivel Recomendado</mat-label>
                <input matInput formControlName="okLevel" type="number">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Nivel Máximo</mat-label>
                <input matInput formControlName="maxLevel" type="number">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Notificación Stock</mat-label>
                <mat-select formControlName="flagAlert">
                    <mat-option value="Y">Si</mat-option>
                    <mat-option value="N">No</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>Configuración Manual</mat-label>
                <mat-select formControlName="flagManualSet">
                    <mat-option value="Y">Si</mat-option>
                    <mat-option value="N">No</mat-option>
                </mat-select>
            </mat-form-field>   
            
            
            <mat-form-field class="w-full">
                <mat-label> Criterio Cálculo </mat-label>
                <mat-select formControlName="codPsWarehouseStorageLevelDay">
                    <ng-container *ngFor="let d of storageLevelDay">
                        <mat-option [value]="d.COD_PS_WAREHOUSE_STORAGE_LEVEL_DAY">
                            {{d.NAME_PS_WAREHOUSE_STORAGE_LEVEL_DAY}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>

            <div class="flex justify-end">
                
                <button mat-raised-button color="primary" *ngIf="data.update == true" (click)="create()" [disabled]="storageLevelForm.invalid"> Actualizar </button>
                <button mat-raised-button color="primary" *ngIf="data.update == false" (click)="create()" [disabled]="storageLevelForm.invalid"> Crear </button>
            </div>
        </form>
    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->        
    </div>
    <!--############################################################-->    
</div>